import { render, staticRenderFns } from "./EventForm.vue?vue&type=template&id=6b3c5486"
import script from "./EventForm.vue?vue&type=script&lang=js"
export * from "./EventForm.vue?vue&type=script&lang=js"
import style0 from "./EventForm.vue?vue&type=style&index=0&id=6b3c5486&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports